import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hd-validation-error',
  templateUrl: './validation-error.component.html',
  styleUrls: ['./validation-error.component.less']
})
export class ValidationErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
